function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';

var Profitwell = function (_React$Component) {
  _inherits(Profitwell, _React$Component);

  function Profitwell() {
    var _temp, _this, _ret;

    _classCallCheck(this, Profitwell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      hasInit: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Profitwell.prototype.componentDidUpdate = function componentDidUpdate() {
    var _window = window,
        profitwell = _window.profitwell;
    var hasInit = this.state.hasInit;
    if (!profitwell || hasInit) return;
    var email = this.props.email;

    if (email) {
      profitwell('user_email', email);
      this.setState({
        hasInit: true
      });
    }
  };

  Profitwell.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        shouldNotLoad = _props.shouldNotLoad,
        authToken = _props.authToken;
    if (shouldNotLoad) return;

    if (!authToken) {
      console.error('ERROR: property authToken is required');
      return;
    } // Beginning of Profitwell Awesomeness Code (which loads totally asynchronously)

    /* eslint-disable */


    (function (i, s, o, g, r, a, m) {
      i.ProfitWellObject = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();
      a = s.createElement(o), m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://dna8twue3dlxq.cloudfront.net/js/profitwell.js', 'profitwell');
    /* eslint-enable */


    if (window.profitwell) window.profitwell('auth_token', authToken);
  };

  Profitwell.prototype.render = function render() {
    return null;
  };

  return Profitwell;
}(React.Component);

export default Profitwell;